/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  appname: 'Silva App',
  urlbase: 'https://api-silvaapp.entregadigital.app.br/api/v1/app/',

  ds: '&dM4_', // Descryptor Hash

  oneSignalAppID: '',
  oneSignalSafariWebID: '',
  subdomainName: '',



  PSPDFKitKey: '',
  PSPDFKitHost: '',

  version:'1.0.8',
};
